import { render, staticRenderFns } from "./PurposeInput.vue?vue&type=template&id=3bc35e5b&scoped=true"
import script from "./PurposeInput.vue?vue&type=script&lang=js"
export * from "./PurposeInput.vue?vue&type=script&lang=js"
import style0 from "./PurposeInput.vue?vue&type=style&index=0&id=3bc35e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc35e5b",
  null
  
)

export default component.exports